import type { JSX } from 'react';
import { ProcessActivityReadContext } from '@frontend/components/pages/episodeCategory/carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { getFilteredSections } from '@frontend/formEngine/readForm/readFormUtils';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import type { ComponentsMap } from './readForm.types';
import { ReadFormSection } from './ReadFormSection';

export function ReadForm({ components }: { components?: ComponentsMap }): JSX.Element[] {
    const { readSections } = useDefinedContext(ProcessActivityReadContext);
    const filteredSections = getFilteredSections(readSections, components);

    return filteredSections.map((readSection) => (
        <ReadFormSection
            components={components}
            key={readSection.items.map((item) => item.key).join('-')}
            section={readSection}
        />
    ));
}
